import { useStaticQuery, graphql } from "gatsby"

export const useNavigation = () => {
  const { allSensaiNavigation } = useStaticQuery(
    graphql`
      query {
        allSensaiNavigation {
          nodes {
            id
            location
            pages {
              __typename
              ... on SENSAIComponentNavigationMainNav {
                navItemPage {
                  id
                  title
                  slug
                }
                navItemLandingPage {
                  id
                  title
                  slug
                }
                navItemName
                sectionGroup
              }
              ... on SENSAIComponentNavigationHyperlink {
                url
                navItemName
                sectionGroup
              }
            }
            button {
              ...ButtonDetails
            }
          }
        }
      }
    `
  )

  return allSensaiNavigation.nodes
}
